<style scoped>
.carousel {
    max-width: 100%;
}

.carousel-inner {
    background: rgba(17, 24, 32, .85);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 1.25rem;
    padding: 25px;
}

.carousel-item h4 {
    font-family: "Barlow Condensed", sans-serif;
    letter-spacing: .5px;
    margin-bottom: 20px;
}

.table {
    color: #e5e7eb;
    border-color: rgba(255, 255, 255, 0.12);
}

.table th {
    color: #9ca3af;
    font-weight: 500;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.table td {
    border: 1px solid gray;
}

button {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    font-weight: 600;
}

.btn-outline-secondary {
    border-color: rgba(255, 255, 255, 0.12);
    
}

.btn-outline-secondary:hover {
    background: rgba(255, 255, 255, .05);
}

.btn-warning {
    background: rgba(255, 106, 0, .15);
    border-color: #ff6a00;
    
}

.btn-secondary {
    background: rgba(255, 255, 255, .06);
    border: 1px solid rgba(255, 255, 255, 0.12);
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
    
}

.carousel-controls {
    position: absolute;
    top: 15px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    pointer-events: none;
}

.carousel-control-prev,
.carousel-control-next {
    pointer-events: all;
}

@media (max-width: 767px) {

    .carousel-inner {
        padding: 15px;
    }

    button {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }

    .carousel-control-next-icon,
    .carousel-control-prev-icon {
        width: 1rem;
    }
}
</style>
<template>

    <div id="monthCarousel" class="carousel slide" data-bs-ride="carousel">

        <div class="carousel-inner shadow-soft">

            <div v-for="(mes, index) in mesesUsados" :key="index" :class="['carousel-item', { active: index === 0 }]">

                <h4 class="text-center text-white">{{ mes.mes }} {{ mes.year }}</h4>

                <div class="table-responsive">

                    <table class="table text-center">

                        <thead>
                            <tr>
                                <th scope="col">Lun</th>
                                <th scope="col">Mar</th>
                                <th scope="col">Mié</th>
                                <th scope="col">Jue</th>
                                <th scope="col">Vie</th>
                                <th scope="col">Sáb</th>
                                <th scope="col">Dom</th>
                            </tr>
                        </thead>

                        <tbody>

                            <tr v-for="(week, weekIndex) in generateWeeks(mes)" :key="weekIndex">

                                <td v-for="(day, dayIndex) in week" :key="dayIndex">

                                    <span v-if="day && fechasDisponibles.includes('!' + day)"
                                        title="Sin disponibilidad para la seleccion de estadía">

                                        <button class="btn btn-dark" disabled style="">
                                            {{ day.slice(-2) }}
                                        </button>

                                    </span>

                                    <button v-else-if="day && fechasDisponibles.includes(day)" :class="{
                                        'btn btn-warning': !isDaySelected(day),
                                        'btn btn-success': isDaySelected(day),
                                        'btn btn-outline-secondary': !fechasDisponibles.includes(day)
                                    }" @click="handleDayClick(day)">

                                        {{ day.slice(-2) }}

                                    </button>

                                    <button v-else-if="day && !fechasDisponibles.includes(day)"
                                        class="btn btn-outline-secondary" disabled>

                                        {{ day.slice(-2) }}

                                    </button>

                                </td>
                            </tr>

                        </tbody>
                    </table>

                </div>
            </div>
        </div>

        <div class="carousel-controls">

            <button class="carousel-control-prev" type="button" data-bs-target="#monthCarousel" data-bs-slide="prev">

                <span class="carousel-control-prev-icon"></span>

            </button>

            <button class="carousel-control-next" type="button" data-bs-target="#monthCarousel" data-bs-slide="next">

                <span class="carousel-control-next-icon"></span>

            </button>

        </div>

    </div>

</template>

<script>
export default {
    props: {
        fechasDisponibles: {
            type: Array,
            required: true,
            default: () => []
        },
        diasSeleccionados: Array
    },
    data() {
        return {

        };
    },
    computed: {
        mesesUsados() {
            const meses = [];
            const nombresMeses = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];

            const mesesSet = new Set();

            this.fechasDisponibles.forEach(pFecha => {
                let fecha = pFecha.replace('!', '');
                const [year, month] = fecha.split('-'); // Extrae año y mes
                const mesNombre = nombresMeses[parseInt(month, 10) - 1]; // Obtiene el nombre del mes
                const key = `${mesNombre}-${year}`;

                if (!mesesSet.has(key)) {
                    mesesSet.add(key);
                    meses.push({ mes: mesNombre, year: parseInt(year, 10) });
                }
            });

            return meses;
        }
    },
    methods: {
        generateWeeks(mes) {
            const diasEnMes = new Date(mes.year, this.mesNumber(mes.mes) + 1, 0).getDate();
            const primerDiaMes = new Date(mes.year, this.mesNumber(mes.mes), 1).getDay();
            const weeks = [];
            let week = [];
            let primerDia = primerDiaMes === 0 ? 7 : primerDiaMes;

            for (let i = 1; i < primerDia; i++) {
                week.push(null);
            }

            for (let i = 1; i <= diasEnMes; i++) {
                const dia = `${mes.year}-${String(this.mesNumber(mes.mes) + 1).padStart(2, '0')}-${String(i).padStart(2, '0')}`;
                week.push(dia);

                if (week.length === 7) {
                    weeks.push(week);
                    week = [];
                }
            }

            if (week.length) {
                while (week.length < 7) {
                    week.push(null);
                }
                weeks.push(week);
            }
            return weeks;
        },
        mesNumber(mes) {
            const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            return meses.indexOf(mes);
        },
        handleDayClick(dia) {
            this.$emit('toggle-day', dia);
        },
        isDaySelected(dia) {
            return this.diasSeleccionados.includes(dia);
        }
    }
};
</script>